import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { reportService } from '../../services/reportService';

export const useGetCashMovementsList = params => {
  return useQuery({
    queryKey: [QUERY_KEYS.report.cash_movements, params],
    queryFn: () =>
      reportService.cashMovements({ limit: 10, ...params }).then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        throw new Error('Fetch failed');
      }),
  });
};
